export var AccessGroupEntityType;
(function (AccessGroupEntityType) {
    AccessGroupEntityType["NETWORK"] = "network";
    AccessGroupEntityType["POST"] = "post";
    AccessGroupEntityType["SPACE"] = "space";
})(AccessGroupEntityType || (AccessGroupEntityType = {}));
export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["FAILED"] = "failed";
    ActionStatus["SUCCEEDED"] = "succeeded";
})(ActionStatus || (ActionStatus = {}));
export var AppCollaboratorType;
(function (AppCollaboratorType) {
    AppCollaboratorType["COLLABORATOR"] = "COLLABORATOR";
    AppCollaboratorType["OWNER"] = "OWNER";
})(AppCollaboratorType || (AppCollaboratorType = {}));
export var AppInstallationStatus;
(function (AppInstallationStatus) {
    AppInstallationStatus["DELETED"] = "DELETED";
    AppInstallationStatus["DISABLED"] = "DISABLED";
    AppInstallationStatus["ENABLED"] = "ENABLED";
})(AppInstallationStatus || (AppInstallationStatus = {}));
export var BadgeType;
(function (BadgeType) {
    BadgeType["ADMIN"] = "Admin";
    BadgeType["MANUAL"] = "Manual";
    BadgeType["MODERATOR"] = "Moderator";
    BadgeType["NEW_MEMBER"] = "NewMember";
})(BadgeType || (BadgeType = {}));
export var CollectionListOrderByEnum;
(function (CollectionListOrderByEnum) {
    CollectionListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    CollectionListOrderByEnum["CUSTOM_ORDERING_INDEX"] = "CUSTOM_ORDERING_INDEX";
    CollectionListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(CollectionListOrderByEnum || (CollectionListOrderByEnum = {}));
export var CustomCodePosition;
(function (CustomCodePosition) {
    CustomCodePosition["BODY"] = "BODY";
    CustomCodePosition["HEAD"] = "HEAD";
})(CustomCodePosition || (CustomCodePosition = {}));
export var CustomFieldPrivacyOptions;
(function (CustomFieldPrivacyOptions) {
    CustomFieldPrivacyOptions["ADMIN"] = "ADMIN";
    CustomFieldPrivacyOptions["OWN"] = "OWN";
})(CustomFieldPrivacyOptions || (CustomFieldPrivacyOptions = {}));
export var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["ARRAY"] = "array";
    CustomFieldType["BOOLEAN"] = "boolean";
    CustomFieldType["DATE"] = "date";
    CustomFieldType["NUMBER"] = "number";
    CustomFieldType["OBJECT"] = "object";
    CustomFieldType["RELATION"] = "relation";
    CustomFieldType["RICH_TEXT"] = "richText";
    CustomFieldType["TEXT"] = "text";
})(CustomFieldType || (CustomFieldType = {}));
export var CustomFieldValidators;
(function (CustomFieldValidators) {
    CustomFieldValidators["ALL_OF"] = "allOf";
    CustomFieldValidators["ANY_OF"] = "anyOf";
    CustomFieldValidators["ENUM"] = "enum";
    CustomFieldValidators["EXCLUSIVE_MAXIMUM"] = "exclusiveMaximum";
    CustomFieldValidators["EXCLUSIVE_MINIMUM"] = "exclusiveMinimum";
    CustomFieldValidators["FORMAT"] = "format";
    CustomFieldValidators["MAX_ITEMS"] = "maxItems";
    CustomFieldValidators["MAX_LENGTH"] = "maxLength";
    CustomFieldValidators["MAX_PROPERTIES"] = "maxProperties";
    CustomFieldValidators["MAXIMUM"] = "maximum";
    CustomFieldValidators["MIN_ITEMS"] = "minItems";
    CustomFieldValidators["MIN_LENGTH"] = "minLength";
    CustomFieldValidators["MIN_PROPERTIES"] = "minProperties";
    CustomFieldValidators["MINIMUM"] = "minimum";
    CustomFieldValidators["MULTIPLE_OF"] = "multipleOf";
    CustomFieldValidators["NOT"] = "not";
    CustomFieldValidators["ONE_OF"] = "oneOf";
    CustomFieldValidators["PATTERN"] = "pattern";
    CustomFieldValidators["UNIQUE_ITEMS"] = "uniqueItems";
})(CustomFieldValidators || (CustomFieldValidators = {}));
export var CustomSsoType;
(function (CustomSsoType) {
    CustomSsoType["OAUTH2"] = "oauth2";
})(CustomSsoType || (CustomSsoType = {}));
export var DateTypeOptions;
(function (DateTypeOptions) {
    DateTypeOptions["DATE"] = "date";
    DateTypeOptions["DATETIME"] = "datetime";
})(DateTypeOptions || (DateTypeOptions = {}));
export var DefaultSsoType;
(function (DefaultSsoType) {
    DefaultSsoType["FACEBOOK"] = "facebook";
    DefaultSsoType["GOOGLE"] = "google";
    DefaultSsoType["LINKEDIN"] = "linkedin";
})(DefaultSsoType || (DefaultSsoType = {}));
export var EmailStatus;
(function (EmailStatus) {
    EmailStatus["BLOCKED"] = "BLOCKED";
    EmailStatus["BOUNCED"] = "BOUNCED";
    EmailStatus["CREATED"] = "CREATED";
    EmailStatus["DEFERRED"] = "DEFERRED";
    EmailStatus["DELIVERED"] = "DELIVERED";
    EmailStatus["DROPPED"] = "DROPPED";
    EmailStatus["PROCESSED"] = "PROCESSED";
    EmailStatus["SENT"] = "SENT";
})(EmailStatus || (EmailStatus = {}));
export var EmailType;
(function (EmailType) {
    EmailType["COLLABORATOR_INVITATION"] = "CollaboratorInvitation";
    EmailType["EMAIL_VERIFICATION"] = "EmailVerification";
    EmailType["MEMBER_CONFIRMATION"] = "MemberConfirmation";
    EmailType["MEMBER_INVITATION"] = "MemberInvitation";
    EmailType["NOTIFICATION"] = "Notification";
    EmailType["RESET_PASSWORD"] = "ResetPassword";
    EmailType["UNKNOWN"] = "Unknown";
})(EmailType || (EmailType = {}));
export var EventVerb;
(function (EventVerb) {
    EventVerb["ACCEPTED"] = "ACCEPTED";
    EventVerb["ADDED"] = "ADDED";
    EventVerb["BANNED"] = "BANNED";
    EventVerb["BLOCKED"] = "BLOCKED";
    EventVerb["CANCELED"] = "CANCELED";
    EventVerb["CREATED"] = "CREATED";
    EventVerb["DELETED"] = "DELETED";
    EventVerb["EXPIRED"] = "EXPIRED";
    EventVerb["FAILED"] = "FAILED";
    EventVerb["FOLLOWED"] = "FOLLOWED";
    EventVerb["HIDDEN"] = "HIDDEN";
    EventVerb["PERMITTED"] = "PERMITTED";
    EventVerb["PINGED"] = "PINGED";
    EventVerb["PINNED"] = "PINNED";
    EventVerb["PUBLISHED"] = "PUBLISHED";
    EventVerb["REJECTED"] = "REJECTED";
    EventVerb["REMOVED"] = "REMOVED";
    EventVerb["REVOKED"] = "REVOKED";
    EventVerb["UNBLOCKED"] = "UNBLOCKED";
    EventVerb["UNFOLLOWED"] = "UNFOLLOWED";
    EventVerb["UNHIDDEN"] = "UNHIDDEN";
    EventVerb["UNPINNED"] = "UNPINNED";
    EventVerb["UNPUBLISHED"] = "UNPUBLISHED";
    EventVerb["UNVERIFIED"] = "UNVERIFIED";
    EventVerb["UPDATED"] = "UPDATED";
    EventVerb["VERIFIED"] = "VERIFIED";
    EventVerb["VIEWED"] = "VIEWED";
})(EventVerb || (EventVerb = {}));
export var ExtraPropertyEntityType;
(function (ExtraPropertyEntityType) {
    ExtraPropertyEntityType["MEMBER"] = "Member";
    ExtraPropertyEntityType["NETWORK"] = "Network";
})(ExtraPropertyEntityType || (ExtraPropertyEntityType = {}));
export var Filtername;
(function (Filtername) {
    Filtername["AND"] = "and";
    Filtername["LEAF"] = "leaf";
    Filtername["OR"] = "or";
})(Filtername || (Filtername = {}));
export var FlaggedType;
(function (FlaggedType) {
    FlaggedType["MEMBER"] = "MEMBER";
    FlaggedType["SYSTEM"] = "SYSTEM";
})(FlaggedType || (FlaggedType = {}));
export var HighlightedTagType;
(function (HighlightedTagType) {
    HighlightedTagType["SECTION"] = "SECTION";
    HighlightedTagType["TOPIC"] = "TOPIC";
})(HighlightedTagType || (HighlightedTagType = {}));
export var ImportRequestStage;
(function (ImportRequestStage) {
    ImportRequestStage["ANSWER"] = "ANSWER";
    ImportRequestStage["COMMENT"] = "COMMENT";
    ImportRequestStage["DISCUSSION"] = "DISCUSSION";
    ImportRequestStage["FIX_POST_TYPES"] = "FIX_POST_TYPES";
    ImportRequestStage["MEMBER"] = "MEMBER";
    ImportRequestStage["QUESTION"] = "QUESTION";
    ImportRequestStage["SPACE"] = "SPACE";
    ImportRequestStage["TOPIC"] = "TOPIC";
})(ImportRequestStage || (ImportRequestStage = {}));
export var ImportRequestStatus;
(function (ImportRequestStatus) {
    ImportRequestStatus["DONE"] = "DONE";
    ImportRequestStatus["IN_PROGRESS"] = "IN_PROGRESS";
})(ImportRequestStatus || (ImportRequestStatus = {}));
export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["CANCELLED"] = "cancelled";
    InvoiceStatus["FAILED"] = "failed";
    InvoiceStatus["PAID"] = "paid";
    InvoiceStatus["PENDING"] = "pending";
})(InvoiceStatus || (InvoiceStatus = {}));
export var MemberEmailStatus;
(function (MemberEmailStatus) {
    MemberEmailStatus["NOT_DELIVERED"] = "notDelivered";
    MemberEmailStatus["SENT"] = "sent";
    MemberEmailStatus["SPAMMED"] = "spammed";
    MemberEmailStatus["VERIFIED"] = "verified";
})(MemberEmailStatus || (MemberEmailStatus = {}));
export var MemberInvitationStatus;
(function (MemberInvitationStatus) {
    MemberInvitationStatus["ACCEPTED"] = "accepted";
    MemberInvitationStatus["DELIVERED"] = "delivered";
    MemberInvitationStatus["NOT_DELIVERED"] = "notDelivered";
    MemberInvitationStatus["NOT_SENT"] = "notSent";
    MemberInvitationStatus["REJECTED"] = "rejected";
    MemberInvitationStatus["SENT"] = "sent";
    MemberInvitationStatus["SPAMMED"] = "spammed";
})(MemberInvitationStatus || (MemberInvitationStatus = {}));
export var MemberListFilterByOperator;
(function (MemberListFilterByOperator) {
    MemberListFilterByOperator["CONTAINS"] = "contains";
    MemberListFilterByOperator["EQUALS"] = "equals";
    MemberListFilterByOperator["GT"] = "gt";
    MemberListFilterByOperator["GTE"] = "gte";
    MemberListFilterByOperator["LT"] = "lt";
    MemberListFilterByOperator["LTE"] = "lte";
    MemberListFilterByOperator["NOT"] = "not";
})(MemberListFilterByOperator || (MemberListFilterByOperator = {}));
export var MemberStatus;
(function (MemberStatus) {
    MemberStatus["BLOCKED"] = "BLOCKED";
    MemberStatus["DELETED"] = "DELETED";
    MemberStatus["REMOVED"] = "REMOVED";
    MemberStatus["UNVERIFIED"] = "UNVERIFIED";
    MemberStatus["VERIFIED"] = "VERIFIED";
})(MemberStatus || (MemberStatus = {}));
export var MemberStatusInput;
(function (MemberStatusInput) {
    MemberStatusInput["BLOCKED"] = "BLOCKED";
    MemberStatusInput["UNVERIFIED"] = "UNVERIFIED";
    MemberStatusInput["VERIFIED"] = "VERIFIED";
})(MemberStatusInput || (MemberStatusInput = {}));
export var ModerationEntityType;
(function (ModerationEntityType) {
    ModerationEntityType["MEMBER"] = "MEMBER";
    ModerationEntityType["POST"] = "POST";
})(ModerationEntityType || (ModerationEntityType = {}));
export var ModerationStatus;
(function (ModerationStatus) {
    ModerationStatus["ACCEPTED"] = "ACCEPTED";
    ModerationStatus["REJECTED"] = "REJECTED";
    ModerationStatus["REVIEW"] = "REVIEW";
})(ModerationStatus || (ModerationStatus = {}));
export var NavigationItemType;
(function (NavigationItemType) {
    NavigationItemType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
    NavigationItemType["PRIMARY_LINK"] = "PRIMARY_LINK";
    NavigationItemType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
    NavigationItemType["TEXT_LINK"] = "TEXT_LINK";
})(NavigationItemType || (NavigationItemType = {}));
export var NetworkIndustryType;
(function (NetworkIndustryType) {
    NetworkIndustryType["BLOGGER_COACH_CREATOR"] = "BloggerCoachCreator";
    NetworkIndustryType["CONSULTING_AND_AGENCY"] = "ConsultingAndAgency";
    NetworkIndustryType["ECOMERCE_AND_RETAIL"] = "EcomerceAndRetail";
    NetworkIndustryType["ENTERTAINMENT_AND_EVENTS"] = "EntertainmentAndEvents";
    NetworkIndustryType["FINANCIAN_SERVICES"] = "FinancianServices";
    NetworkIndustryType["HEALTHCARE"] = "Healthcare";
    NetworkIndustryType["INTERNET_AND_ONLINE_SERVICE"] = "InternetAndOnlineService";
    NetworkIndustryType["MEDIA_AND_PUBLISHING"] = "MediaAndPublishing";
    NetworkIndustryType["NON_PROFIT_AND_ASSOCIATION"] = "NonProfitAndAssociation";
    NetworkIndustryType["ONLINE_TRAINING_AND_EDUCATION"] = "OnlineTrainingAndEducation";
    NetworkIndustryType["OTHER"] = "Other";
    NetworkIndustryType["SOFTWARE_AND_SAAS"] = "SoftwareAndSaas";
})(NetworkIndustryType || (NetworkIndustryType = {}));
export var NetworkLandingPage;
(function (NetworkLandingPage) {
    NetworkLandingPage["EXPLORE"] = "EXPLORE";
    NetworkLandingPage["FEED"] = "FEED";
    NetworkLandingPage["SPACES"] = "SPACES";
})(NetworkLandingPage || (NetworkLandingPage = {}));
export var NetworkMembership;
(function (NetworkMembership) {
    NetworkMembership["INVITE_ONLY"] = "inviteOnly";
    NetworkMembership["OPEN"] = "open";
})(NetworkMembership || (NetworkMembership = {}));
export var NetworkPasswordComplexity;
(function (NetworkPasswordComplexity) {
    NetworkPasswordComplexity["COMPLEX"] = "Complex";
    NetworkPasswordComplexity["SIMPLE"] = "Simple";
    NetworkPasswordComplexity["STANDARD"] = "Standard";
})(NetworkPasswordComplexity || (NetworkPasswordComplexity = {}));
export var NetworkPrimaryMembersType;
(function (NetworkPrimaryMembersType) {
    NetworkPrimaryMembersType["CUSTOMERS"] = "Customers";
    NetworkPrimaryMembersType["EMPLOYEES"] = "Employees";
    NetworkPrimaryMembersType["MEMBERS"] = "Members";
    NetworkPrimaryMembersType["OTHER"] = "Other";
    NetworkPrimaryMembersType["STUDENTS"] = "Students";
})(NetworkPrimaryMembersType || (NetworkPrimaryMembersType = {}));
export var NetworkReleaseChannelType;
(function (NetworkReleaseChannelType) {
    NetworkReleaseChannelType["EDGE"] = "edge";
    NetworkReleaseChannelType["STABLE"] = "stable";
})(NetworkReleaseChannelType || (NetworkReleaseChannelType = {}));
export var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus["ARCHIVED"] = "archived";
    NetworkStatus["PUBLISHED"] = "published";
    NetworkStatus["UNPUBLISHED"] = "unpublished";
})(NetworkStatus || (NetworkStatus = {}));
export var NetworkStatusChangedBy;
(function (NetworkStatusChangedBy) {
    NetworkStatusChangedBy["ADMIN"] = "admin";
    NetworkStatusChangedBy["SUPPORT"] = "support";
    NetworkStatusChangedBy["SYSTEM"] = "system";
})(NetworkStatusChangedBy || (NetworkStatusChangedBy = {}));
export var NetworkStatusReason;
(function (NetworkStatusReason) {
    NetworkStatusReason["MEMBER_CAPACITY_EXCEEDED"] = "memberCapacityExceeded";
    NetworkStatusReason["NETWORK_CREATED"] = "networkCreated";
    NetworkStatusReason["NETWORK_LOCK_LIFTED"] = "networkLockLifted";
    NetworkStatusReason["SEATS_CAPACITY_EXCEEDED"] = "seatsCapacityExceeded";
})(NetworkStatusReason || (NetworkStatusReason = {}));
export var NetworkTimeframeType;
(function (NetworkTimeframeType) {
    NetworkTimeframeType["FEW_MONTHS"] = "FewMonths";
    NetworkTimeframeType["FEW_WEEKS"] = "FewWeeks";
    NetworkTimeframeType["NOT_SURE"] = "NotSure";
    NetworkTimeframeType["VERY_SOON"] = "VerySoon";
})(NetworkTimeframeType || (NetworkTimeframeType = {}));
export var NetworkVisibility;
(function (NetworkVisibility) {
    NetworkVisibility["PRIVATE"] = "private";
    NetworkVisibility["PUBLIC"] = "public";
})(NetworkVisibility || (NetworkVisibility = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["DESKTOP"] = "DESKTOP";
    NotificationChannel["EMAIL"] = "EMAIL";
    NotificationChannel["IN_APP"] = "IN_APP";
})(NotificationChannel || (NotificationChannel = {}));
export var NotificationReason;
(function (NotificationReason) {
    NotificationReason["NETWORK_ADMIN"] = "NETWORK_ADMIN";
    NotificationReason["NETWORK_SUBSCRIPTION"] = "NETWORK_SUBSCRIPTION";
    NotificationReason["POST_AUTHOR"] = "POST_AUTHOR";
    NotificationReason["POST_SUBSCRIPTION"] = "POST_SUBSCRIPTION";
    NotificationReason["SPACE_ADMIN"] = "SPACE_ADMIN";
    NotificationReason["SPACE_SUBSCRIPTION"] = "SPACE_SUBSCRIPTION";
})(NotificationReason || (NotificationReason = {}));
export var NotificationVerb;
(function (NotificationVerb) {
    NotificationVerb["COMMENT_CREATED"] = "COMMENT_CREATED";
    NotificationVerb["COMMENT_DELETED"] = "COMMENT_DELETED";
    NotificationVerb["COMMENT_UPDATED"] = "COMMENT_UPDATED";
    NotificationVerb["JOIN_REQUEST_STATUS_UPDATED"] = "JOIN_REQUEST_STATUS_UPDATED";
    NotificationVerb["MEMBER_MENTIONED"] = "MEMBER_MENTIONED";
    NotificationVerb["POST_CREATED"] = "POST_CREATED";
    NotificationVerb["POST_DELETED"] = "POST_DELETED";
    NotificationVerb["POST_FOLLOWED"] = "POST_FOLLOWED";
    NotificationVerb["POST_UPDATED"] = "POST_UPDATED";
    NotificationVerb["REACTION_CREATED"] = "REACTION_CREATED";
    NotificationVerb["REPLY_CREATED"] = "REPLY_CREATED";
    NotificationVerb["SPACE_MEMBER_ADDED"] = "SPACE_MEMBER_ADDED";
})(NotificationVerb || (NotificationVerb = {}));
export var NumberTypeOptions;
(function (NumberTypeOptions) {
    NumberTypeOptions["INTEGER"] = "integer";
    NumberTypeOptions["NUMBER"] = "number";
})(NumberTypeOptions || (NumberTypeOptions = {}));
export var PageSeoTagType;
(function (PageSeoTagType) {
    PageSeoTagType["LINK"] = "LINK";
    PageSeoTagType["META"] = "META";
    PageSeoTagType["TITLE"] = "TITLE";
})(PageSeoTagType || (PageSeoTagType = {}));
export var PayloadType;
(function (PayloadType) {
    PayloadType["JOIN_REQUEST_STATUS"] = "JOIN_REQUEST_STATUS";
    PayloadType["MEMBER"] = "MEMBER";
    PayloadType["NETWORK"] = "NETWORK";
    PayloadType["POST"] = "POST";
    PayloadType["REACTION"] = "REACTION";
    PayloadType["SPACE"] = "SPACE";
})(PayloadType || (PayloadType = {}));
export var PermissionContext;
(function (PermissionContext) {
    PermissionContext["MEMBER"] = "MEMBER";
    PermissionContext["NETWORK"] = "NETWORK";
    PermissionContext["POST"] = "POST";
    PermissionContext["SPACE"] = "SPACE";
})(PermissionContext || (PermissionContext = {}));
export var PinnedInto;
(function (PinnedInto) {
    PinnedInto["MEMBER"] = "member";
    PinnedInto["NETWORK"] = "network";
    PinnedInto["POST"] = "post";
    PinnedInto["SPACE"] = "space";
})(PinnedInto || (PinnedInto = {}));
export var PlanName;
(function (PlanName) {
    PlanName["BASIC"] = "basic";
    PlanName["ENTERPRISE"] = "enterprise";
    PlanName["PLUS"] = "plus";
    PlanName["PREMIUM"] = "premium";
})(PlanName || (PlanName = {}));
export var PlanRenewalType;
(function (PlanRenewalType) {
    PlanRenewalType["MONTH"] = "month";
    PlanRenewalType["YEAR"] = "year";
})(PlanRenewalType || (PlanRenewalType = {}));
export var PostFieldsEnum;
(function (PostFieldsEnum) {
    PostFieldsEnum["BOOLEAN1"] = "boolean1";
    PostFieldsEnum["BOOLEAN2"] = "boolean2";
    PostFieldsEnum["BOOLEAN3"] = "boolean3";
    PostFieldsEnum["BOOLEAN4"] = "boolean4";
    PostFieldsEnum["BOOLEAN5"] = "boolean5";
    PostFieldsEnum["DATE1"] = "date1";
    PostFieldsEnum["DATE2"] = "date2";
    PostFieldsEnum["DATE3"] = "date3";
    PostFieldsEnum["DATE4"] = "date4";
    PostFieldsEnum["DATE5"] = "date5";
    PostFieldsEnum["HTML1"] = "html1";
    PostFieldsEnum["HTML2"] = "html2";
    PostFieldsEnum["HTML3"] = "html3";
    PostFieldsEnum["HTML4"] = "html4";
    PostFieldsEnum["HTML5"] = "html5";
    PostFieldsEnum["HTML6"] = "html6";
    PostFieldsEnum["HTML7"] = "html7";
    PostFieldsEnum["HTML8"] = "html8";
    PostFieldsEnum["HTML9"] = "html9";
    PostFieldsEnum["HTML10"] = "html10";
    PostFieldsEnum["IMAGE1"] = "image1";
    PostFieldsEnum["IMAGE2"] = "image2";
    PostFieldsEnum["IMAGE3"] = "image3";
    PostFieldsEnum["IMAGE4"] = "image4";
    PostFieldsEnum["IMAGE5"] = "image5";
    PostFieldsEnum["NUMBER1"] = "number1";
    PostFieldsEnum["NUMBER2"] = "number2";
    PostFieldsEnum["NUMBER3"] = "number3";
    PostFieldsEnum["NUMBER4"] = "number4";
    PostFieldsEnum["NUMBER5"] = "number5";
    PostFieldsEnum["NUMBER_ARRAY1"] = "numberArray1";
    PostFieldsEnum["NUMBER_ARRAY2"] = "numberArray2";
    PostFieldsEnum["NUMBER_ARRAY3"] = "numberArray3";
    PostFieldsEnum["NUMBER_ARRAY4"] = "numberArray4";
    PostFieldsEnum["NUMBER_ARRAY5"] = "numberArray5";
    PostFieldsEnum["TEXT1"] = "text1";
    PostFieldsEnum["TEXT2"] = "text2";
    PostFieldsEnum["TEXT3"] = "text3";
    PostFieldsEnum["TEXT4"] = "text4";
    PostFieldsEnum["TEXT5"] = "text5";
    PostFieldsEnum["TEXT6"] = "text6";
    PostFieldsEnum["TEXT7"] = "text7";
    PostFieldsEnum["TEXT8"] = "text8";
    PostFieldsEnum["TEXT9"] = "text9";
    PostFieldsEnum["TEXT10"] = "text10";
    PostFieldsEnum["TEXT_ARRAY1"] = "textArray1";
    PostFieldsEnum["TEXT_ARRAY2"] = "textArray2";
    PostFieldsEnum["TEXT_ARRAY3"] = "textArray3";
    PostFieldsEnum["TEXT_ARRAY4"] = "textArray4";
    PostFieldsEnum["TEXT_ARRAY5"] = "textArray5";
})(PostFieldsEnum || (PostFieldsEnum = {}));
export var PostListFilterByEnum;
(function (PostListFilterByEnum) {
    PostListFilterByEnum["BOOLEAN1"] = "boolean1";
    PostListFilterByEnum["BOOLEAN2"] = "boolean2";
    PostListFilterByEnum["BOOLEAN3"] = "boolean3";
    PostListFilterByEnum["BOOLEAN4"] = "boolean4";
    PostListFilterByEnum["BOOLEAN5"] = "boolean5";
    PostListFilterByEnum["CREATED_AT"] = "createdAt";
    PostListFilterByEnum["DATE1"] = "date1";
    PostListFilterByEnum["DATE2"] = "date2";
    PostListFilterByEnum["DATE3"] = "date3";
    PostListFilterByEnum["DATE4"] = "date4";
    PostListFilterByEnum["DATE5"] = "date5";
    PostListFilterByEnum["NUMBER1"] = "number1";
    PostListFilterByEnum["NUMBER2"] = "number2";
    PostListFilterByEnum["NUMBER3"] = "number3";
    PostListFilterByEnum["NUMBER4"] = "number4";
    PostListFilterByEnum["NUMBER5"] = "number5";
    PostListFilterByEnum["UPDATED_AT"] = "updatedAt";
})(PostListFilterByEnum || (PostListFilterByEnum = {}));
export var PostListFilterByOperator;
(function (PostListFilterByOperator) {
    PostListFilterByOperator["EQUALS"] = "equals";
    PostListFilterByOperator["GT"] = "gt";
    PostListFilterByOperator["GTE"] = "gte";
    PostListFilterByOperator["IN"] = "in";
    PostListFilterByOperator["LT"] = "lt";
    PostListFilterByOperator["LTE"] = "lte";
    PostListFilterByOperator["NOT"] = "not";
})(PostListFilterByOperator || (PostListFilterByOperator = {}));
export var PostListOrderByEnum;
(function (PostListOrderByEnum) {
    PostListOrderByEnum["BOOLEAN1"] = "boolean1";
    PostListOrderByEnum["BOOLEAN2"] = "boolean2";
    PostListOrderByEnum["BOOLEAN3"] = "boolean3";
    PostListOrderByEnum["BOOLEAN4"] = "boolean4";
    PostListOrderByEnum["BOOLEAN5"] = "boolean5";
    PostListOrderByEnum["CREATED_AT"] = "createdAt";
    PostListOrderByEnum["DATE1"] = "date1";
    PostListOrderByEnum["DATE2"] = "date2";
    PostListOrderByEnum["DATE3"] = "date3";
    PostListOrderByEnum["DATE4"] = "date4";
    PostListOrderByEnum["DATE5"] = "date5";
    PostListOrderByEnum["NEGATIVE_REACTIONS_COUNT"] = "negativeReactionsCount";
    PostListOrderByEnum["NUMBER1"] = "number1";
    PostListOrderByEnum["NUMBER2"] = "number2";
    PostListOrderByEnum["NUMBER3"] = "number3";
    PostListOrderByEnum["NUMBER4"] = "number4";
    PostListOrderByEnum["NUMBER5"] = "number5";
    PostListOrderByEnum["POSITIVE_REACTIONS_COUNT"] = "positiveReactionsCount";
    PostListOrderByEnum["REACTIONS_COUNT"] = "reactionsCount";
    PostListOrderByEnum["REPLIES_COUNT"] = "repliesCount";
    PostListOrderByEnum["TEXT1"] = "text1";
    PostListOrderByEnum["TEXT2"] = "text2";
    PostListOrderByEnum["TEXT3"] = "text3";
    PostListOrderByEnum["TEXT4"] = "text4";
    PostListOrderByEnum["TEXT5"] = "text5";
    PostListOrderByEnum["TOTAL_REPLIES_COUNT"] = "totalRepliesCount";
    PostListOrderByEnum["UPDATED_AT"] = "updatedAt";
})(PostListOrderByEnum || (PostListOrderByEnum = {}));
export var PostMappingTypeEnum;
(function (PostMappingTypeEnum) {
    PostMappingTypeEnum["BOOLEAN"] = "boolean";
    PostMappingTypeEnum["DATE"] = "date";
    PostMappingTypeEnum["HTML"] = "html";
    PostMappingTypeEnum["IMAGE"] = "image";
    PostMappingTypeEnum["NUMBER"] = "number";
    PostMappingTypeEnum["NUMBER_ARRAY"] = "numberArray";
    PostMappingTypeEnum["TEXT"] = "text";
    PostMappingTypeEnum["TEXT_ARRAY"] = "textArray";
})(PostMappingTypeEnum || (PostMappingTypeEnum = {}));
export var PostStatus;
(function (PostStatus) {
    PostStatus["ARCHIVED"] = "ARCHIVED";
    PostStatus["BLOCKED"] = "BLOCKED";
    PostStatus["DELETED"] = "DELETED";
    PostStatus["DRAFTED"] = "DRAFTED";
    PostStatus["PUBLISHED"] = "PUBLISHED";
})(PostStatus || (PostStatus = {}));
export var PostTypeContext;
(function (PostTypeContext) {
    PostTypeContext["POST"] = "post";
    PostTypeContext["REPLY"] = "reply";
})(PostTypeContext || (PostTypeContext = {}));
export var PrimaryScopes;
(function (PrimaryScopes) {
    PrimaryScopes["ALL_ACCESS"] = "ALL_ACCESS";
    PrimaryScopes["ASSIGN_BADGE"] = "ASSIGN_BADGE";
    PrimaryScopes["IMPERSONATE_MEMBER"] = "IMPERSONATE_MEMBER";
    PrimaryScopes["UPDATE_BADGE"] = "UPDATE_BADGE";
    PrimaryScopes["UPDATE_NETWORK"] = "UPDATE_NETWORK";
    PrimaryScopes["VIEW_APP"] = "VIEW_APP";
    PrimaryScopes["VIEW_APP_INSTALLATION"] = "VIEW_APP_INSTALLATION";
    PrimaryScopes["VIEW_BILLING_SUBSCRIPTION"] = "VIEW_BILLING_SUBSCRIPTION";
    PrimaryScopes["VIEW_IMPORT_REQUEST"] = "VIEW_IMPORT_REQUEST";
    PrimaryScopes["VIEW_MEMBER"] = "VIEW_MEMBER";
    PrimaryScopes["VIEW_MEMBER_INVITATION"] = "VIEW_MEMBER_INVITATION";
    PrimaryScopes["VIEW_MODERATION"] = "VIEW_MODERATION";
    PrimaryScopes["VIEW_NETWORK"] = "VIEW_NETWORK";
    PrimaryScopes["VIEW_NETWORK_PLAN"] = "VIEW_NETWORK_PLAN";
    PrimaryScopes["VIEW_ORGANIZATION"] = "VIEW_ORGANIZATION";
    PrimaryScopes["VIEW_POST"] = "VIEW_POST";
    PrimaryScopes["VIEW_ROLE"] = "VIEW_ROLE";
    PrimaryScopes["VIEW_SPACE"] = "VIEW_SPACE";
    PrimaryScopes["VIEW_SPACE_COLLECTION"] = "VIEW_SPACE_COLLECTION";
    PrimaryScopes["VIEW_SPACE_JOIN_REQUEST"] = "VIEW_SPACE_JOIN_REQUEST";
    PrimaryScopes["VIEW_SPACE_MEMBERSHIP"] = "VIEW_SPACE_MEMBERSHIP";
    PrimaryScopes["VIEW_SPACE_ROLE"] = "VIEW_SPACE_ROLE";
    PrimaryScopes["VIEW_SSO"] = "VIEW_SSO";
    PrimaryScopes["VIEW_SSO_MEMBERSHIP"] = "VIEW_SSO_MEMBERSHIP";
    PrimaryScopes["VIEW_SYNC_EVENT"] = "VIEW_SYNC_EVENT";
    PrimaryScopes["VIEW_TRACKER"] = "VIEW_TRACKER";
})(PrimaryScopes || (PrimaryScopes = {}));
export var ReactionType;
(function (ReactionType) {
    ReactionType["EMOJI_BASE"] = "EMOJI_BASE";
    ReactionType["LIKE_BASE"] = "LIKE_BASE";
    ReactionType["VOTE_BASE"] = "VOTE_BASE";
})(ReactionType || (ReactionType = {}));
export var RelationTypeOptions;
(function (RelationTypeOptions) {
    RelationTypeOptions["MEDIA"] = "media";
    RelationTypeOptions["MEMBER"] = "member";
    RelationTypeOptions["POST"] = "post";
    RelationTypeOptions["TAG"] = "tag";
})(RelationTypeOptions || (RelationTypeOptions = {}));
export var ReportCategory;
(function (ReportCategory) {
    ReportCategory["HARASSMENT"] = "HARASSMENT";
    ReportCategory["MISINFORMATION"] = "MISINFORMATION";
    ReportCategory["NUDITY"] = "NUDITY";
    ReportCategory["SPAM"] = "SPAM";
    ReportCategory["SUICIDE"] = "SUICIDE";
    ReportCategory["TERRORISM"] = "TERRORISM";
    ReportCategory["VIOLENCE"] = "VIOLENCE";
})(ReportCategory || (ReportCategory = {}));
export var ReportDataType;
(function (ReportDataType) {
    ReportDataType["CHART_DATA"] = "chartData";
    ReportDataType["ENTITY_REPORT"] = "entityReport";
    ReportDataType["INT_VALUE"] = "intValue";
    ReportDataType["STRING_VALUE"] = "stringValue";
})(ReportDataType || (ReportDataType = {}));
export var ReportSlug;
(function (ReportSlug) {
    ReportSlug["ACTIVE_MEMBERS"] = "activeMembers";
    ReportSlug["AVERAGE_DAILY_ACTIVE_MEMBERS"] = "averageDailyActiveMembers";
    ReportSlug["HIGHLIGHTS"] = "highlights";
    ReportSlug["MEMBER_SCORE"] = "memberScore";
    ReportSlug["NEW_MEMBERS_OVER_TIME"] = "newMembersOverTime";
    ReportSlug["NEW_POSTS"] = "newPosts";
    ReportSlug["NEW_REACTIONS"] = "newReactions";
    ReportSlug["NEW_REPLIES"] = "newReplies";
    ReportSlug["POPULAR_DAYS_OF_WEEK"] = "popularDaysOfWeek";
    ReportSlug["POPULAR_HOURS_OF_DAY"] = "popularHoursOfDay";
    ReportSlug["POSTS_V_SREPLIES"] = "postsVSreplies";
    ReportSlug["TOP_MEMBERS"] = "topMembers";
    ReportSlug["TOP_POSTS"] = "topPosts";
    ReportSlug["TOP_SPACES"] = "topSpaces";
    ReportSlug["TOTAL_MEMBERS"] = "totalMembers";
    ReportSlug["TOTAL_POSTS"] = "totalPosts";
    ReportSlug["TOTAL_REACTIONS"] = "totalReactions";
    ReportSlug["TOTAL_REPLIES"] = "totalReplies";
    ReportSlug["TOTAL_VISITORS"] = "totalVisitors";
    ReportSlug["TRENDING_TAGS"] = "trendingTags";
})(ReportSlug || (ReportSlug = {}));
export var ReportTimeFrame;
(function (ReportTimeFrame) {
    ReportTimeFrame["ALL_TIME"] = "allTime";
    ReportTimeFrame["LAST_CALENDAR_QUARTER"] = "lastCalendarQuarter";
    ReportTimeFrame["LAST_CALENDAR_YEAR"] = "lastCalendarYear";
    ReportTimeFrame["LAST_MONTH"] = "lastMonth";
    ReportTimeFrame["LAST_NINETY_DAYS"] = "lastNinetyDays";
    ReportTimeFrame["LAST_SEVEN_DAYS"] = "lastSevenDays";
    ReportTimeFrame["LAST_THIRTY_DAYS"] = "lastThirtyDays";
    ReportTimeFrame["LAST_TWELVE_MONTH"] = "lastTwelveMonth";
    ReportTimeFrame["LAST_WEEK"] = "lastWeek";
    ReportTimeFrame["TODAY"] = "today";
    ReportTimeFrame["YESTERDAY"] = "yesterday";
})(ReportTimeFrame || (ReportTimeFrame = {}));
export var ReportableEntityType;
(function (ReportableEntityType) {
    ReportableEntityType["MEMBER"] = "member";
    ReportableEntityType["POST"] = "post";
    ReportableEntityType["SPACE"] = "space";
    ReportableEntityType["TOPIC"] = "topic";
})(ReportableEntityType || (ReportableEntityType = {}));
export var RichTextTypeOptions;
(function (RichTextTypeOptions) {
    RichTextTypeOptions["HTML"] = "html";
    RichTextTypeOptions["MARKUP"] = "markup";
})(RichTextTypeOptions || (RichTextTypeOptions = {}));
export var RoleListOrderByEnum;
(function (RoleListOrderByEnum) {
    RoleListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    RoleListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(RoleListOrderByEnum || (RoleListOrderByEnum = {}));
export var RoleType;
(function (RoleType) {
    RoleType["ADMIN"] = "admin";
    RoleType["GUEST"] = "guest";
    RoleType["MEMBER"] = "member";
    RoleType["MODERATOR"] = "moderator";
})(RoleType || (RoleType = {}));
export var SearchEntityType;
(function (SearchEntityType) {
    SearchEntityType["MEMBER"] = "member";
    SearchEntityType["POST"] = "post";
    SearchEntityType["SPACE"] = "space";
})(SearchEntityType || (SearchEntityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SpaceJoinRequestStatus;
(function (SpaceJoinRequestStatus) {
    SpaceJoinRequestStatus["COMPLETED"] = "COMPLETED";
    SpaceJoinRequestStatus["DECLINED"] = "DECLINED";
    SpaceJoinRequestStatus["PENDING"] = "PENDING";
})(SpaceJoinRequestStatus || (SpaceJoinRequestStatus = {}));
export var SpaceListOrderByEnum;
(function (SpaceListOrderByEnum) {
    SpaceListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    SpaceListOrderByEnum["CUSTOM_ORDERING_INDEX"] = "CUSTOM_ORDERING_INDEX";
    SpaceListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(SpaceListOrderByEnum || (SpaceListOrderByEnum = {}));
export var SpaceMemberListOrderByEnum;
(function (SpaceMemberListOrderByEnum) {
    SpaceMemberListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    SpaceMemberListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(SpaceMemberListOrderByEnum || (SpaceMemberListOrderByEnum = {}));
export var SpaceMembershipStatus;
(function (SpaceMembershipStatus) {
    SpaceMembershipStatus["JOINED"] = "joined";
    SpaceMembershipStatus["NOT_JOINED"] = "notJoined";
    SpaceMembershipStatus["REQUESTED"] = "requested";
})(SpaceMembershipStatus || (SpaceMembershipStatus = {}));
export var SpaceNotificationPreference;
(function (SpaceNotificationPreference) {
    SpaceNotificationPreference["ALL"] = "ALL";
    SpaceNotificationPreference["NEW_POST"] = "NEW_POST";
    SpaceNotificationPreference["NONE"] = "NONE";
})(SpaceNotificationPreference || (SpaceNotificationPreference = {}));
export var SpaceRoleListOrderByEnum;
(function (SpaceRoleListOrderByEnum) {
    SpaceRoleListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    SpaceRoleListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(SpaceRoleListOrderByEnum || (SpaceRoleListOrderByEnum = {}));
export var SpaceRoleType;
(function (SpaceRoleType) {
    SpaceRoleType["ADMIN"] = "admin";
    SpaceRoleType["MEMBER"] = "member";
})(SpaceRoleType || (SpaceRoleType = {}));
export var SpaceType;
(function (SpaceType) {
    SpaceType["BROADCAST"] = "Broadcast";
    SpaceType["ENTITY"] = "Entity";
    SpaceType["GROUP"] = "Group";
    SpaceType["PAGE"] = "Page";
    SpaceType["PRIVATE_MESSAGE"] = "PrivateMessage";
})(SpaceType || (SpaceType = {}));
export var SsoProvider;
(function (SsoProvider) {
    SsoProvider["AUTH0"] = "auth0";
    SsoProvider["CUSTOM"] = "custom";
    SsoProvider["MEMBERFUL"] = "memberful";
    SsoProvider["OKTA"] = "okta";
    SsoProvider["OUTSETA"] = "outseta";
    SsoProvider["WORDPRESS"] = "wordpress";
})(SsoProvider || (SsoProvider = {}));
export var SsoStatus;
(function (SsoStatus) {
    SsoStatus["DISABLE"] = "disable";
    SsoStatus["ENABLE"] = "enable";
})(SsoStatus || (SsoStatus = {}));
export var SsoType;
(function (SsoType) {
    SsoType["FACEBOOK"] = "facebook";
    SsoType["GOOGLE"] = "google";
    SsoType["JWT"] = "jwt";
    SsoType["LINKEDIN"] = "linkedin";
    SsoType["OAUTH2"] = "oauth2";
})(SsoType || (SsoType = {}));
export var StoreItemStanding;
(function (StoreItemStanding) {
    StoreItemStanding["OFFICIAL"] = "OFFICIAL";
    StoreItemStanding["REGULAR"] = "REGULAR";
    StoreItemStanding["VERIFIED"] = "VERIFIED";
})(StoreItemStanding || (StoreItemStanding = {}));
export var StoreItemStatus;
(function (StoreItemStatus) {
    StoreItemStatus["DELETED"] = "DELETED";
    StoreItemStatus["PRIVATE"] = "PRIVATE";
    StoreItemStatus["PUBLIC"] = "PUBLIC";
})(StoreItemStatus || (StoreItemStatus = {}));
export var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "active";
    SubscriptionStatus["CANCELED"] = "canceled";
    SubscriptionStatus["FAILED"] = "failed";
    SubscriptionStatus["INCOMPLETE"] = "incomplete";
    SubscriptionStatus["INCOMPLETE_EXPIRED"] = "incomplete_expired";
    SubscriptionStatus["PAST_DUE"] = "past_due";
    SubscriptionStatus["TRIALING"] = "trialing";
    SubscriptionStatus["UNPAID"] = "unpaid";
})(SubscriptionStatus || (SubscriptionStatus = {}));
export var TagFilterType;
(function (TagFilterType) {
    TagFilterType["BLACKLIST"] = "BLACKLIST";
    TagFilterType["WHITELIST"] = "WHITELIST";
})(TagFilterType || (TagFilterType = {}));
export var TagListOrderByEnum;
(function (TagListOrderByEnum) {
    TagListOrderByEnum["CREATED_AT"] = "CREATED_AT";
    TagListOrderByEnum["UPDATED_AT"] = "UPDATED_AT";
})(TagListOrderByEnum || (TagListOrderByEnum = {}));
export var TemplateEntityType;
(function (TemplateEntityType) {
    TemplateEntityType["POST"] = "Post";
    TemplateEntityType["POST_TYPE"] = "PostType";
    TemplateEntityType["SPACE"] = "Space";
    TemplateEntityType["SPACE_POST_TYPE"] = "SpacePostType";
    TemplateEntityType["TAG"] = "Tag";
})(TemplateEntityType || (TemplateEntityType = {}));
export var TextTypeOptions;
(function (TextTypeOptions) {
    TextTypeOptions["FULL_TEXT"] = "fullText";
    TextTypeOptions["SHORT_TEXT"] = "shortText";
})(TextTypeOptions || (TextTypeOptions = {}));
export var ThemeStatus;
(function (ThemeStatus) {
    ThemeStatus["DRAFT"] = "draft";
    ThemeStatus["PUBLISHED"] = "published";
})(ThemeStatus || (ThemeStatus = {}));
export var TopNavigationAlignment;
(function (TopNavigationAlignment) {
    TopNavigationAlignment["CENTER"] = "CENTER";
    TopNavigationAlignment["LEFT"] = "LEFT";
    TopNavigationAlignment["RIGHT"] = "RIGHT";
})(TopNavigationAlignment || (TopNavigationAlignment = {}));
export var UnauthorizedReason;
(function (UnauthorizedReason) {
    UnauthorizedReason["ACCESS"] = "ACCESS";
    UnauthorizedReason["PLAN"] = "PLAN";
})(UnauthorizedReason || (UnauthorizedReason = {}));
export var UnsubscribeTokenContext;
(function (UnsubscribeTokenContext) {
    UnsubscribeTokenContext["ALL"] = "ALL";
    UnsubscribeTokenContext["MEMBER"] = "MEMBER";
    UnsubscribeTokenContext["MENTIONS"] = "MENTIONS";
    UnsubscribeTokenContext["POST"] = "POST";
    UnsubscribeTokenContext["REACTIONS"] = "REACTIONS";
    UnsubscribeTokenContext["SPACE"] = "SPACE";
})(UnsubscribeTokenContext || (UnsubscribeTokenContext = {}));
export var UseTemplateRequestStatus;
(function (UseTemplateRequestStatus) {
    UseTemplateRequestStatus["FAILED"] = "Failed";
    UseTemplateRequestStatus["IN_PROGRESS"] = "InProgress";
    UseTemplateRequestStatus["SUCCEEDED"] = "Succeeded";
})(UseTemplateRequestStatus || (UseTemplateRequestStatus = {}));
export var VatType;
(function (VatType) {
    VatType["AE_TRN"] = "ae_trn";
    VatType["AU_ABN"] = "au_abn";
    VatType["AU_ARN"] = "au_arn";
    VatType["BR_CNPJ"] = "br_cnpj";
    VatType["BR_CPF"] = "br_cpf";
    VatType["CA_BN"] = "ca_bn";
    VatType["CA_GST_HST"] = "ca_gst_hst";
    VatType["CA_PST_BC"] = "ca_pst_bc";
    VatType["CA_PST_MB"] = "ca_pst_mb";
    VatType["CA_PST_SK"] = "ca_pst_sk";
    VatType["CA_QST"] = "ca_qst";
    VatType["CH_VAT"] = "ch_vat";
    VatType["CL_TIN"] = "cl_tin";
    VatType["ES_CIF"] = "es_cif";
    VatType["EU_VAT"] = "eu_vat";
    VatType["GB_VAT"] = "gb_vat";
    VatType["HK_BR"] = "hk_br";
    VatType["ID_NPWP"] = "id_npwp";
    VatType["IL_VAT"] = "il_vat";
    VatType["IN_GST"] = "in_gst";
    VatType["JP_CN"] = "jp_cn";
    VatType["JP_RN"] = "jp_rn";
    VatType["KR_BRN"] = "kr_brn";
    VatType["LI_UID"] = "li_uid";
    VatType["MX_RFC"] = "mx_rfc";
    VatType["MY_FRP"] = "my_frp";
    VatType["MY_ITN"] = "my_itn";
    VatType["MY_SST"] = "my_sst";
    VatType["NO_VAT"] = "no_vat";
    VatType["NZ_GST"] = "nz_gst";
    VatType["RU_INN"] = "ru_inn";
    VatType["RU_KPP"] = "ru_kpp";
    VatType["SA_VAT"] = "sa_vat";
    VatType["SG_GST"] = "sg_gst";
    VatType["SG_UEN"] = "sg_uen";
    VatType["TH_VAT"] = "th_vat";
    VatType["TW_VAT"] = "tw_vat";
    VatType["US_EIN"] = "us_ein";
    VatType["ZA_VAT"] = "za_vat";
})(VatType || (VatType = {}));
export var WidgetContexts;
(function (WidgetContexts) {
    WidgetContexts["MEMBER"] = "MEMBER";
    WidgetContexts["POST"] = "POST";
    WidgetContexts["SPACE"] = "SPACE";
})(WidgetContexts || (WidgetContexts = {}));
export var WidgetPositions;
(function (WidgetPositions) {
    WidgetPositions["PAGE"] = "PAGE";
    WidgetPositions["SIDEBAR"] = "SIDEBAR";
})(WidgetPositions || (WidgetPositions = {}));
const result = {
    "possibleTypes": {
        "By": [
            "Member"
        ],
        "In": [
            "Space"
        ],
        "Media": [
            "Emoji",
            "File",
            "Image"
        ],
        "ModerationItemEntity": [
            "Member",
            "Post"
        ],
        "PageEntity": [
            "Collection",
            "Member",
            "Post"
        ],
        "ReportDataValue": [
            "ChartData",
            "EntityReport",
            "IntValue",
            "StringValue"
        ],
        "ReportableEntity": [
            "Member",
            "Post",
            "Space",
            "Tag"
        ],
        "SlateComponentOrPlaceholder": [
            "SlateComponent",
            "SlatePlaceholder"
        ],
        "UseTemplateCreatedEntity": [
            "Space"
        ]
    }
};
export default result;
//# sourceMappingURL=tribe-graphql.generated.js.map